var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.8 28.8",
    style: {
      enableBackground: "new 0 0 28.8 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,22.2c1.6,0.6,3.2,1.3,4.8,1.9c3.2,1.3,6.5,2.6,9.7,3.9c0.1,0,0.3,0.1,0.4,0.1h0c0.6,0,1.1-0.5,1.1-1.1 V14.4V1.9c0-0.6-0.5-1.1-1.1-1.1h0c-0.1,0-0.3,0-0.4,0.1c-3.2,1.3-6.4,2.6-9.7,3.9C13.8,6,10.7,7.2,7.6,8.5 C7.1,8.6,6.6,8.8,6.1,8.8c-1.5,0-3,0-4.6,0c-0.7,0-0.8,0.1-0.8,0.8c0,1.6,0,3.2,0,4.8s0,3.2,0,4.9c0,0.7,0.2,0.8,0.8,0.8 c1.5,0,3,0,4.6,0c0.2,0,0.4,0,0.6,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,20.1c-0.6,0.6-1,1.4-1,2.3c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2c0-0.1,0-0.2,0-0.2 c-1.5-0.6-3-1.2-4.6-1.8C7.3,20.2,7,20.2,6.8,20.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.422641fe375221f23e25b5afb34180ce.svg";
export { ForwardRef as ReactComponent };